import log from 'loglevel'
import axios from 'axios'

import Cache from '../utils/cache'

/* eslint class-methods-use-this: ["off"] */

export default class Phase {
  constructor() {
    log.info('[INFO] Initialize Phase Module')
    this.cache = new Cache()
  }

  fetchPhases(params) {
    let parameters = {}

    if (params) {
      parameters = {
        params: {
          p: params.p,
          page_size: params.page_size,
          search: params.q,
        },
      }
    }

    const result = this.cache.bind(parameters, 10, () => {
      const promise = new Promise((resolve, reject) => {
        axios
          .get('v1/bidding/phase/', parameters)
          .then(response => {
            log.debug('[DEBUG] Success to fetch phases')
            resolve(response)
          })
          .catch(error => {
            log.error('[ERROR] Fail to fetch phases')
            log.error(error)
            reject(error.response)
          })
      })
      return promise
    })
    return result
  }

  fetchPhase(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`v1/bidding/phase/${id}/`)
        .then(response => {
          log.debug('[DEBUG] Success to fetch phase')
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to fetch phase')
          log.error(error)
          reject(error.response)
        })
    })
  }

  updatePhase(id, phaseData) {
    return new Promise((resolve, reject) => {
      axios
        .put(`v1/bidding/phase/${id}/`, phaseData)
        .then(response => {
          log.debug('[DEBUG] Success to update phase')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to update phase')
          log.error(error)
          reject(error.response)
        })
    })
  }

  addPhase(phaseData) {
    return new Promise((resolve, reject) => {
      axios
        .post('v1/bidding/phase/', phaseData)
        .then(response => {
          log.debug('[DEBUG] Success to add phase')
          this.cache.reset()
          resolve(response)
        })
        .catch(error => {
          log.error('[ERROR] Fail to add phase')
          log.error(error)
          reject(error.response)
        })
    })
  }

  deletePhase(id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`v1/bidding/phase/${id}/`)
        .then(() => {
          log.debug('[DEBUG] Success to delete phase')
          this.cache.reset()
          resolve()
        })
        .catch(error => {
          log.error('[ERROR] Fail to delete phase')
          log.error(error)
          reject(error.response)
        })
    })
  }
}
